module.exports = __webpack_public_path__ + "img/拼团多阶玩法.1674df1d.png";